import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IconInstagram } from './icons';
import { BrandLogo } from './BrandLogo';
import { DEALERSHIP } from '../data/dealership';
import { INSTAGRAM_URL, PRIVACY_POLICY_URL, TERMS_URL, DEALER_DISCLOSURE } from '../config';
export function Footer() {
  const {
    t,
    lang
  } = useLanguage();
  const year = new Date().getFullYear();
  return <footer className="w-full bg-ink" data-id="element-85" data-mp="3ueilfwsu32dg">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 sm:px-6" data-id="element-86" data-mp="3ufjujvqahesj">
        <BrandLogo tone="dark" className="h-12 w-12" data-id="element-87" data-mp="38zbozae1d6l" />
        <p className="mt-4 font-display text-sm font-extrabold uppercase tracking-[0.2em] text-white" data-id="element-88" data-mp="36d3cxfoatnb">
          MIAMI CAR QUEENS
        </p>
        <p className="mt-2 text-sm text-white/65" data-id="element-89" data-mp="3qcniknv98gxk">{t('footer.people')}</p>
        <p className="mt-1 text-xs uppercase tracking-[0.16em] text-white/45" data-id="element-90" data-mp="29z6x2jmuoxjl">
          {t('footer.services')}
        </p>

        <div className="mt-8 h-px w-full bg-camel/40" data-id="element-91" data-mp="2eyjqjn8892v5" />

        {/* The dealership where Gabriela and Chanira work. Miami Car Queens is NOT a dealership. */}
        <div className="mt-8" data-id="element-92" data-mp="3lbdcst8dy9lt">
          <p className="text-[11px] uppercase tracking-[0.2em] text-camel" data-id="element-93" data-mp="3gaz73hu9bbqy">
            {t('footer.dealerLabel')}
          </p>
          <p className="mt-2 font-display text-base font-bold text-white" data-id="element-94" data-mp="3v8hq03k96uqh">{DEALERSHIP.name}</p>
          <p className="mt-1 text-sm text-white/65" data-id="element-95" data-mp="3q7u1ppnesrzy">{DEALERSHIP.address}</p>
          <p className="mt-1 text-sm text-white/65" data-id="element-96" data-mp="828n46lrs59o">{DEALERSHIP.hours[lang]}</p>
          <p className="mt-3 max-w-xl text-xs leading-relaxed text-white/45" data-id="element-97" data-mp="3474fms9a7yq">
            {t('footer.notDealer')}
          </p>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-x-5 gap-y-1 text-xs text-white/60" data-id="element-98" data-mp="hrigrqw9hvzw">
          {/* Rendered only when the config URL is non-empty. */}
          {INSTAGRAM_URL ? <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex min-h-[44px] items-center gap-2 hover:text-gold" data-id="element-99" data-mp="qub81u5g27pq">
              <IconInstagram className="h-5 w-5" data-id="element-100" data-mp="two4vw6mvl8d" />
              {t('footer.instagram')}
            </a> : null}
          {PRIVACY_POLICY_URL ? <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" className="flex min-h-[44px] items-center hover:text-gold" data-id="element-101" data-mp="13sr1ynmmotog">
              {t('form.privacy')}
            </a> : null}
          {TERMS_URL ? <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" className="flex min-h-[44px] items-center hover:text-gold" data-id="element-102" data-mp="1hjw8m9oeym8a">
              {t('form.terms')}
            </a> : null}
        </div>

        {/* Small print, rendered only if the disclosure constant is non-empty. */}
        {DEALER_DISCLOSURE ? <p className="mt-6 max-w-3xl text-[11px] leading-relaxed text-white/40" data-id="element-103" data-mp="3t9gei849z1kp">
            {DEALER_DISCLOSURE}
          </p> : null}

        <p className="mt-6 text-[11px] text-white/35" data-id="element-104" data-mp="2ah85mxmwhcw1">© {year} Miami Car Queens</p>
      </div>
    </footer>;
}